import { DocusignData } from '@digital-platform/docusign/domain';
import { DomainModelHelper, EntityBase } from '@digital-platform/shared/domain';
import { ThirdPartyAuthDetails } from '../waste-profiles-domain';

export class ThirdPartyAuthModel
  extends EntityBase
  implements ThirdPartyAuthDetails
{
  readonly id: string | null;
  readonly authorizationStartDate: Date | null;
  readonly expiryDate: Date | null;
  readonly signNowDocumentUrl: string | null;
  readonly docusignData: DocusignData | null;

  public static readonly DEFAULT_CONFIG: ThirdPartyAuthDetails = {
    id: '',
    authorizationStartDate: null,
    expiryDate: null,
    signNowDocumentUrl: '',
    docusignData: null,
  };

  constructor(config: ThirdPartyAuthDetails) {
    super(config);
    this.id = config
      ? DomainModelHelper.ensureDataIsString(config.id)
      : ThirdPartyAuthModel.DEFAULT_CONFIG.id;
    this.authorizationStartDate = config
      ? DomainModelHelper.ensureDataIsDate(config.authorizationStartDate)
      : ThirdPartyAuthModel.DEFAULT_CONFIG.authorizationStartDate;
    this.expiryDate = config
      ? DomainModelHelper.ensureDataIsDate(config.expiryDate)
      : ThirdPartyAuthModel.DEFAULT_CONFIG.expiryDate;
    this.signNowDocumentUrl = config
      ? DomainModelHelper.ensureDataIsString(config.signNowDocumentUrl)
      : ThirdPartyAuthModel.DEFAULT_CONFIG.signNowDocumentUrl;
    this.docusignData = config ? config.docusignData : null;
  }
}
